import {
  ADMIN_ROLE_IDENTIFIERS,
  ORGANIZER_ROLE_IDENTIFIERS,
  ROLE_LABELS,
  type RoleLabel,
} from "@app/lib/role-constants";

function extractNormalizedRoles(roles: unknown): string[] {
  if (Array.isArray(roles)) {
    return roles
      .filter((role): role is string => typeof role === "string")
      .map((role) => role.trim().toLowerCase());
  }

  if (typeof roles !== "object" || roles === null) {
    return [];
  }

  return Object.values(roles)
    .flatMap((value) =>
      Array.isArray(value)
        ? value.filter((role): role is string => typeof role === "string")
        : [],
    )
    .map((role) => role.trim().toLowerCase());
}

export function getRoleLabelFromJwtRoles(roles: unknown): RoleLabel {
  const normalizedRoles = extractNormalizedRoles(roles);

  const hasAdminRole = normalizedRoles.some((normalizedRole) =>
    ADMIN_ROLE_IDENTIFIERS.some((adminRole) => adminRole === normalizedRole),
  );

  if (hasAdminRole) {
    return ROLE_LABELS.ADMIN;
  }

  const hasOrganizerRole = normalizedRoles.some((normalizedRole) =>
    ORGANIZER_ROLE_IDENTIFIERS.some(
      (organizerRole) => organizerRole === normalizedRole,
    ),
  );

  return hasOrganizerRole ? ROLE_LABELS.ORGANIZER : ROLE_LABELS.UNKNOWN;
}
